import { useMemo } from 'react';

import { useGetAllPrices } from '@/api/pactswap/generated/api';
import { Currency } from '@/constants';

/**
 * Custom hook that wraps useGetAllPrices and provides additional helper methods
 * for working with coin prices.
 */
export const useTokenUsdPrices = () => {
  const queryResult = useGetAllPrices();

  // Memoize the prices map for efficient lookups
  const usdTokenPrices = useMemo(() => {
    if (!queryResult.data?.prices) {
      return new Map<string, number>();
    }

    return new Map(queryResult.data.prices.map((price) => [price.token.toLowerCase(), price.price]));
  }, [queryResult.data?.prices]);

  const getTokenUsdPrice = (token: Currency): number => {
    return usdTokenPrices.get(token.toLowerCase()) ?? 0;
  };

  return {
    // Original query result properties
    ...queryResult,
    // Memoized prices map for direct access
    usdTokenPrices,
    getTokenUsdPrice,
  };
};
